import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  keepPreviousData,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";

import DataGrid from "./components/DataGrid";
import DataGridClient from "./components/DataGridClient";
import DataGridServer from "./components/DataGridServer";
import DetailDataGrid from "./components/DetailDataGrid";
import Tabs from "./components/Tabs";
import TabsDataGrid from "./components/TabsDataGrid";
import DatePicker from "./components/DatePicker";
import DatePickerFormik from "./components/DatePickerFormik";
import AutocompleteC from "./components/Autocomplete";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      placeholderData: keepPreviousData,
    },
  },
});

const App: React.FC = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<DataGrid />} />
          <Route path="/datagrid" element={<DataGrid />} />
          <Route path="/datagrid-client" element={<DataGridClient />} />
          <Route path="/datagrid-server" element={<DataGridServer />} />
          <Route path="/datagrid/:id" element={<DetailDataGrid />} />
          <Route path="/tabs" element={<Tabs />} />
          <Route path="/tabs-datagrid" element={<TabsDataGrid />} />
          <Route path="/datapicker" element={<DatePicker />} />
          <Route path="/datapicker-formik" element={<DatePickerFormik />} />
          <Route path="/autocomplete" element={<AutocompleteC />} />
        </Routes>
      </QueryClientProvider>
    </LocalizationProvider>
  );
};

export default App;
